import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Component, Inject, OnDestroy} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {AudioRecordingService} from '../../services/audio-recording.service';
import {FormBuilder} from '@angular/forms';


@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './create-prompt-dialog.component.html',
    styleUrls: ['./create-prompt-dialog.component.scss']
})

export class CreatePromptDialogComponent implements OnDestroy {

    isRecording = false;
    fileFolder: string;
    fileName: string;
    recordedTime;
    blobUrl;

    constructor(
        private audioRecordingService: AudioRecordingService,
        private sanitizer: DomSanitizer,
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<CreatePromptDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CreateDialogModel
    ) {

        this.audioRecordingService.recordingFailed().subscribe(() => {
            this.isRecording = false;
        });

        this.audioRecordingService.getRecordedTime().subscribe((time) => {
            this.recordedTime = time;
        });

        this.audioRecordingService.getRecordedBlob().subscribe((recordedBlobData) => {
            this.blobUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(recordedBlobData.blob));
        });
    }

    startRecording(): void {
        if (!this.isRecording) {
            this.isRecording = true;
            this.audioRecordingService.startRecording();
        }
    }

    abortRecording(): void {
        if (this.isRecording) {
            this.isRecording = false;
            this.audioRecordingService.abortRecording();
        }
    }

    stopRecording(): void {
        if (this.isRecording) {
            this.audioRecordingService.stopRecording();
            this.isRecording = false;
        }
    }

    clearRecordedData(): void {
        this.blobUrl = null;
    }

    ngOnDestroy(): void {
        this.abortRecording();
    }

    onConfirm(): void {
        this.dialogRef.close();
    }

    onDismiss(): void {
        this.dialogRef.close();
    }
}
export class CreateDialogModel {

    constructor(
        public title: string,
        public message: string,
        public dataName: string,
        public dataValue: string,
        public cancelTitle: string,
        public acceptTitle: string)
    {

    }
}


